import { fetcher } from "helpers/fetcher";

import { TGetBUEmployeeMemberReq, TGetBUEmployeeMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUEmployeeMember = async (
  params?: TGetBUEmployeeMemberReq,
  language?: string
) => {
  return await fetcher<TGetBUEmployeeMemberRes, TGetBUEmployeeMemberReq>(
    ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER.version,
        [API_HEADER.BU_ID]: params?.idBu,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetBUEmployeeMember = async (
  params?: TGetBUEmployeeMemberReq,
  language?: string
) => {
  return (await getBUEmployeeMember(params, language)).data;
};

queryGetBUEmployeeMember._key = (
  params?: TGetBUEmployeeMemberReq,
  language?: string
) => [ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER.url, params, language];
